import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import useGet from '@/core/composables/api/useGet'
import type { LessonImpulse } from '../models/lesson-impulse'

export const useLessonImpulse = () => {
  const route = useRoute()
  const impulseId = computed(() => route.params.id as string)
  const endpoint = computed(() => `lesson-impulse/${impulseId.value}`)

  const { data: impulse, status, load, reload } = useGet<LessonImpulse>(endpoint)

  watch(
    impulseId,
    async () => {
      await load()
    },
    { immediate: true },
  )

  return {
    impulse,
    status,
    reload,
  }
}
